module.exports = __webpack_public_path__ + "static/media/zina-India_BrightBlue.7c526d26.svg";